import React, { Fragment } from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import { toFriendlyDateString } from 'helpers/Formatter';
import { StyledColumn, StyledRow, LeaseSummaryColumnContent } from '../common/LeaseStyles';

const LeaseSummaryColumnTitle = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 22px;
`;

export default function LeaseDetails({
  leaseDetails,
  leaseFormValues,
  selectedUnit,
  selectedUnitType,
}) {
  return (
    <Fragment>
      <StyledRow>
        <StyledColumn md={8}>
          <LeaseSummaryColumnTitle>
            {getTranslatedString(
              'landlordPortal.leaseCreatorV2.leaseSummaryPage.leaseDetails.property'
            )}
          </LeaseSummaryColumnTitle>
          <LeaseSummaryColumnContent>{leaseDetails.property.label}</LeaseSummaryColumnContent>
        </StyledColumn>

        <StyledColumn md={8}>
          <LeaseSummaryColumnTitle>
            {getTranslatedString(
              'landlordPortal.leaseCreatorV2.leaseSummaryPage.leaseDetails.startDate'
            )}
          </LeaseSummaryColumnTitle>
          <LeaseSummaryColumnContent>
            {toFriendlyDateString(leaseDetails.draft_lease_data.lease_start_date)}
          </LeaseSummaryColumnContent>
        </StyledColumn>

        <StyledColumn md={8}>
          <LeaseSummaryColumnTitle>
            {getTranslatedString(
              'landlordPortal.leaseCreatorV2.leaseSummaryPage.leaseDetails.proRatedAmount'
            )}
          </LeaseSummaryColumnTitle>
          <LeaseSummaryColumnContent>
            {leaseFormValues.prorate_rent === true
              ? getTranslatedString(
                  'landlordPortal.leaseCreatorV2.leaseSummaryPage.leaseDetails.yes'
                )
              : getTranslatedString(
                  'landlordPortal.leaseCreatorV2.leaseSummaryPage.leaseDetails.no'
                )}
          </LeaseSummaryColumnContent>
        </StyledColumn>
      </StyledRow>
      <StyledRow>
        <StyledColumn md={8}>
          <LeaseSummaryColumnTitle>
            {getTranslatedString(
              'landlordPortal.leaseCreatorV2.leaseSummaryPage.leaseDetails.unit'
            )}
          </LeaseSummaryColumnTitle>
          <LeaseSummaryColumnContent>{selectedUnit?.label}</LeaseSummaryColumnContent>
        </StyledColumn>
        <StyledColumn>
          <LeaseSummaryColumnTitle>
            {getTranslatedString(
              'landlordPortal.leaseCreatorV2.leaseSummaryPage.leaseDetails.endDate'
            )}
          </LeaseSummaryColumnTitle>
          <LeaseSummaryColumnContent>
            {toFriendlyDateString(leaseDetails.draft_lease_data.lease_end_date)}
          </LeaseSummaryColumnContent>
        </StyledColumn>
      </StyledRow>
      <StyledRow>
        <StyledColumn md={8}>
          <LeaseSummaryColumnTitle>
            {getTranslatedString(
              'landlordPortal.leaseCreatorV2.leaseSummaryPage.leaseDetails.unitType'
            )}
          </LeaseSummaryColumnTitle>
          <LeaseSummaryColumnContent>{selectedUnitType?.label}</LeaseSummaryColumnContent>
        </StyledColumn>
        <StyledColumn md={8}>
          <LeaseSummaryColumnTitle>
            {getTranslatedString(
              'landlordPortal.leaseCreatorV2.leaseSummaryPage.leaseDetails.moveInDate'
            )}
          </LeaseSummaryColumnTitle>
          <LeaseSummaryColumnContent>
            {toFriendlyDateString(leaseDetails.draft_lease_data.early_move_in_date)}
          </LeaseSummaryColumnContent>
        </StyledColumn>
      </StyledRow>
    </Fragment>
  );
}
